import React from 'react'
import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';

const BreadCrumb = ({ data }) => {
  const li_list = [];
  let key = 1;
  for (let i = 0; i < data.length; ++i) {
    let c = data[i];
    if (i === data.length - 1) {
      li_list.push(<li key={key} className="breadcrumb-item active" aria-current="page">{c.title}</li>);
    } else {
      if (c.url) {
        li_list.push(
          <li key={key} className="breadcrumb-item">
            <Link className="link-dark text-decoration-none" to={c.url}>{c.title}</Link>
          </li>
        );
      } else if (c.onClick) {
        li_list.push(
          <li key={key} className="breadcrumb-item">
            <a href="#" onClick={c.onClick}>{c.title}</a>
          </li>
        );
      }
    }
    key += 1;
  }

  return (
    <nav aria-level="breadcrumb">
      <ol className="breadcrumb">
        {li_list}
      </ol>
    </nav>
  );
};

export default hot(module)(BreadCrumb);
